import request from '@/utils/request'

// 查询商品分类信息列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/order/master/page',
        method: 'get',
        params: query,
    })
}
export function categoryList(query) {
    return request({
        url: '/upkeep/complaint/list',
        method: 'get',
        params: query,
    })
}
// 查询商品分类详细
export function getObj(id) {
    return request({
        url: '/upkeep/order/master/detail?id=' + id,
        method: 'get',
    })
}
// 新增商品分类
export function addObj(data) {
    return request({
        url: '/upkeep/service/item/add',
        method: 'post',
        data: data,
    })
}
// 删除商品分类
export function delObj(data) {
    return request({
        url: '/upkeep/service/item/add',
        method: 'post',
        data: data,
    })
}

// 订单投诉完成
export function putObj(data) {
    return request({
        url: '/upkeep/order/master/cancel',
        method: 'post',
        data: data,
    })
}
 

// 更改状态
export function statusObj(data) {
    return request({
        url: '/upkeep/order/master/add',
        method: 'post',
        data: data,
    })
}
// 查询商品分类信息列表分页
export function getServelist(query) {
    return request({
        url: '/upkeep/service/page',
        method: 'get',
        params: query,
    })
}